import type { CSSProperties } from "react";

import Player from "react-lottie-player/dist/LottiePlayerLight";

import path from "./ListeningLottie.json?url";

export function ListeningAnimation({ style }: { style?: CSSProperties }) {
    return <Player style={style} path={path} loop play speed={1} />;
}
